import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { FactorGenericTypes } from "../../app/types/genericTables.types";

type UseFactorGenericTypes = {
  genericFactorList: FactorGenericTypes[];
  get: (id: FactorGenericTypes["id"]) => FactorGenericTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useFactorGeneric = create<UseFactorGenericTypes>((set, get) => ({
  loading: false,
  genericFactorList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) =>
    get().genericFactorList.find((factorGeneric) => factorGeneric.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/FactoresGeometricos";
      const { data: response } = await getData(endpoint);
      set(() => ({
        genericFactorList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useFactorGeneric:", error);
      set({ loading: false });
    }
  },
}));
